export default {
	functional: true,
	name: 'CoinTag',
	props: {
		child: {
			type: Number,
			require: true,
		},
		parent: {
			type: Number,
			require: true,
		},
		parentWidth: {
			type: Number,
			default: 1.835,
		},
		fontColor: {
			type: String,
		},
	},
	render(h, context) {
		return h(
			'div',
			{
				class: 'global-progress',
			},
			[
				h(
					'div',
					{
						class: 'outer',
					},
					[
						h('div', {
							class: 'inner',
							style: {
								width: `${(context.props.child / context.props.parent) * context.props.parentWidth}rem`,
							},
						}),
					]
				),
				h(
					'span',
					{
						class: 'ratio',
						style: {
							color: `${context.props.fontColor}`,
						},
					},
					[
						h(
							'span',
							{
								class: 'view-num',
							},
							context.props.child
						),
						'/',
						context.props.parent,
					]
				),
			]
		);
	},
};



// WEBPACK FOOTER //
// ./src/components/common/Progress.js